import { useNavigate } from "react-router-dom";
import BreadCrumb from "../../../fragments/BreadCrumb";
import BreadCrumbContainer from "../../../fragments/BreadCrumbContainer";
import SubHeader from "../../../fragments/SubHeader";

const SubHeaderHistorialLecciones = () => {
  const navigate = useNavigate();

  return (
    <div className="flex align-middle justify-between items-center">
      <SubHeader styles="!bg-backgroundColor">
        <BreadCrumbContainer>
          <BreadCrumb route={"Inicio /"} onClick={() => navigate("/home")} />
          <BreadCrumb
            route={"Herramientas Nimbus GED /"}
            onClick={() => navigate("/recursos/herramientas")}
          />
          <BreadCrumb route={"Historial de lecciones"} active />
        </BreadCrumbContainer>
      </SubHeader>
    </div>
  );
};

export default SubHeaderHistorialLecciones;
